// removed by extract-text-webpack-plugin
module.exports = {"videoEmbed":"LipyJ","player":"_2USpl","thumbnail":"_22Td9","overlay":"e-x8j","button":"_1Moxh","arrow":"_2ZPdG","icon":"_33WoB"};


//////////////////
// WEBPACK FOOTER
// ./app/components/video-embed/video-embed.scss
// module id = 762
// module chunks = 3 4 5 6 7